import React from 'react';
import ExpandRow from '../ExpandRow';

const TableItem = (props) => {

    const isExpandColumn = (columnName) =>{
        return props.expandOptions &&
            props.expandOptions.enabled &&
            props.expandOptions.column &&
            props.expandOptions.column.toString() === columnName.toString()
    }

    const data = props.columns
        .map((key) => {
            const options = props.columnOptions[key];
            return {
                column: key,
                value: isExpandColumn(key) ?
                    <ExpandRow
                        item={props.item}
                        onExpand={props.onExpand}
                        expanded={props.expanded}
                        options={props.expandOptions}></ExpandRow> :
                    options.template ?
                        options.template(props.item) :
                        options.transform(props.item[key])
            };
        });

    let rowItems = [
        <tr key="row" className={props.rowOptions.classes.join(" ")} onClick={() => props.rowOptions.click(props.item)}>
            {data.map((value, index) => {
                let classes = props.columnOptions[value.column].classes ? props.columnOptions[value.column].classes.join(" ") : "";
                if (isExpandColumn(value.column)) {
                    classes = classes.concat("expand");
                }
                return (<td
                    className={classes}
                    key={index}>{value.value}
                </td>)
            }
            )}
        </tr>]
    if (props.expanded && props.rowOptions.detailTemplate) {
        rowItems.push(<tr key="detail">
            <td className="p-0" colSpan={props.columns.length}>
                {props.rowOptions.detailTemplate(props.item)}
            </td>
        </tr>);
    }

    return rowItems;
}

export default TableItem;